import GenericRequest, { METHOD_POST } from '../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../shared/webservices/endpoint';
import RouterUtils from '../../../../shared/routing/RouterUtils';

export default class TaskChangeStatesRequest extends GenericRequest {

    taskStateId;

    constructor(taskId, taskStateId) {
        super(METHOD_POST, RouterUtils.generateRoute(ApiEndpoints.TASK_CHANGE_STATE, { id: taskId }));

        this.taskStateId = taskStateId;
    }

    overrideRequest() {
        const request = {};
        if ( this.taskStateId ) request.task_state_id = this.taskStateId;
        return request;
    }

}



// WEBPACK FOOTER //
// ./src/app/my-outsources/tasks/list/ws/TaskChangeStatesRequest.js